import { Model } from "@tailflow/laravel-orion/lib/model";

export class PaymentTerms extends Model<{
  name: string;
  description: string;
  days: number;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "payment-terms";
  }
}
